import React, { useState } from "react";
import { useEffect } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Stack, Typography } from "@mui/material";
import { getUserById, getMessages } from "../../../apis";
import { format } from "timeago.js";
const Conversation = ({ data, currentUser, online, name }) => {
  const [userData, setUserData] = useState(null);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // const userId = data.members.find((id) => id !== currentUser);
    const dataID = data._id;
    // const getUserData = async () => {
    //   try {
    //     const { data } = await getUserById(userId);
    //     setUserData(data.user);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    const fetchMessages = async () => {
      try {
        const { data } = await getMessages(dataID);
        setMessages(data);
      } catch (error) {
        console.log(error);
      }
    };

    if (data !== null) fetchMessages();

    // getUserData();
  }, []);
  return (
    <>
      <div className="follower conversation">
        <div>
          {online && <div className="online-dot"></div>}
          <Stack direction="row" spacing={2}>
            <AccountCircleIcon
              className="followerImage ammanat-darker-gray"
              style={{ width: "40px", height: "40px" }}
            />
            <Stack direction="column" style={{ width: "100%" }}>
              <Stack direction="row" justifyContent="space-between">
                <Typography
                  style={{ textTransform: "capitalize", fontSize: "15px" }}
                >
                  {name}
                </Typography>
                <Typography
                  style={{ fontSize: "11px" }}
                  className="ammanat-darker-gray"
                >
                  {format(messages[messages.length - 1]?.createdAt)}
                </Typography>
              </Stack>

              <Typography
                className="cut-text ammanat-darker-gray"
                style={{ fontSize: "13px" }}
              >
                {messages[messages.length - 1]?.text}
              </Typography>
            </Stack>
          </Stack>
        </div>
      </div>
      <hr style={{ width: "85%", border: "0.1px solid #ececec" }} />
    </>
  );
};

export default Conversation;
